import React, { useState, useEffect } from 'react';
import * as moment from 'moment';
import ReactDatePicker from 'react-datepicker';
import useSelectAsesores from '../../../hooks/useSelectAsesores';
import { filtrarLlamadas } from '../../../actions/leadsActions';
import { useDispatch } from 'react-redux';
import { avisoError } from '../../components/AvisosMensajes/MensajesSwalf';

const FormularioFiltroLlamadas = ({ setDatosTabla, setLoading, usuario }) => {
    const [fechaInicio, setFechaInicio] = useState(moment().startOf('month').toDate());
    const [fechaFin, setFechaFin] = useState(new Date());
    const [asesor, SelectAsesor] = useSelectAsesores(null);
    const [estado, setEstado] = useState('');
    const [turno, setTurno] = useState('');
    const dispatch = useDispatch();

    const fetchData = async (filtros) => {
        setLoading(true);
        const rpta = await dispatch(filtrarLlamadas(filtros));
        if (rpta) {
            setDatosTabla(rpta);
            localStorage.setItem('reporte_llamadas_cache', JSON.stringify(rpta));
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData({
            asesor: null,
            fechaFiltroDesde: moment().startOf('month').format('YYYY-MM-DD'),
            fechaFiltroHasta: moment().format('YYYY-MM-DD'),
            estado: null,
            nivel: usuario.id_tp_nivel_usuario,
            turno: '',
        });
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const aplicar = () => {
        if (!fechaInicio || !fechaFin) { avisoError('Selecciona un rango de fechas'); return; }
        fetchData({
            asesor: asesor || null,
            fechaFiltroDesde: moment(fechaInicio).format('YYYY-MM-DD'),
            fechaFiltroHasta: moment(fechaFin).format('YYYY-MM-DD'),
            estado: estado !== '' ? estado : null,
            nivel: usuario.id_tp_nivel_usuario,
            turno,
        });
    };

    const limpiar = () => {
        setFechaInicio(moment().startOf('month').toDate());
        setFechaFin(new Date());
        setEstado('');
        setTurno('');
        fetchData({
            asesor: null,
            fechaFiltroDesde: moment().startOf('month').format('YYYY-MM-DD'),
            fechaFiltroHasta: moment().format('YYYY-MM-DD'),
            estado: null,
            nivel: usuario.id_tp_nivel_usuario,
            turno: '',
        });
    };

    return (
        <div className="row align-items-end mx-n1 mb-2">
            <div className="col-md-3 px-1">
                <label className="small font-weight-bold mb-1">Asesor</label>
                <SelectAsesor />
            </div>
            <div className="col-md-1 px-1">
                <label className="small font-weight-bold mb-1">Turno</label>
                <select className="form-control form-control-sm" value={turno} onChange={e => setTurno(e.target.value)}>
                    <option value="">Todos</option>
                    <option value="1">T1</option>
                    <option value="2">T2</option>
                </select>
            </div>
            <div className="col-md-2 px-1">
                <label className="small font-weight-bold mb-1">Desde</label>
                <ReactDatePicker
                    selected={fechaInicio}
                    onChange={date => setFechaInicio(date)}
                    selectsStart
                    dateFormat="dd/MM/yyyy"
                    className="form-control form-control-sm"
                    autoComplete="off"
                />
            </div>
            <div className="col-md-2 px-1">
                <label className="small font-weight-bold mb-1">Hasta</label>
                <ReactDatePicker
                    selected={fechaFin}
                    onChange={date => setFechaFin(date)}
                    dateFormat="dd/MM/yyyy"
                    className="form-control form-control-sm"
                    startDate={fechaInicio}
                    endDate={fechaFin}
                    minDate={fechaInicio}
                    autoComplete="off"
                />
            </div>
            <div className="col-md-2 px-1">
                <label className="small font-weight-bold mb-1">Estado</label>
                <select className="form-control form-control-sm" value={estado} onChange={e => setEstado(e.target.value)}>
                    <option value="">Todos</option>
                    <option value="1">Completado</option>
                    <option value="0">Pendiente</option>
                    <option value="2">Vencidas</option>
                </select>
            </div>
            <div className="col-md-2 px-1 d-flex" style={{ gap: '4px' }}>
                <button className="btn btn-primary btn-sm flex-grow-1" onClick={aplicar}>
                    <i className="fas fa-search mr-1"></i>Aplicar filtros
                </button>
                <button className="btn btn-outline-secondary btn-sm" onClick={limpiar} title="Limpiar">
                    <i className="fas fa-times"></i>
                </button>
            </div>
        </div>
    );
};

export default FormularioFiltroLlamadas;
